var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-item',{staticClass:"relative",attrs:{"title":_vm.contentItem.title,"icon":"icon-downloads","primary":true}},_vm._l((_vm.contentItem.items),function(item,index){return _c('div',{key:index},[_c('sidebar-card-download-file',{staticClass:"download-item",attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }